




"use strict";

export default class SearchTabs {

    constructor (resultTabs, resultSections) {
        if ( resultTabs && resultSections ) {
            this.resultTabs = resultTabs;
            this.resultSections = resultSections;

            this.items = {};
            this.currentItem = undefined;

            this.resultTabs.querySelector('li:first-child').classList.add('current');
            this.resultSections.forEach(section => {
                this.items[section.dataset.slug] = section.dataset.name;
            });

            this.addTabsButtons();
            this.addEvents();
        }
    }

    addEvents () {
        this.resultTabs.querySelectorAll('li')
            .forEach(btn => btn.addEventListener('click', () => {
                this.currentItem = btn.dataset.slug;

                if (!this.currentItem) {
                    this.setAllSectionsVisible();
                } else {
                    this.setCurrentSectionVisible();
                }
            })
        );
    }

    addTabsButtons () {
        for ( const item in this.items ) {
            const elem = document.createElement('li');
            elem.dataset.slug = item;
            elem.innerHTML = this.items[item];

            this.resultTabs.append(elem);
        }
    }

    setAllSectionsVisible () {
        this.resultSections
            .forEach(section => section.style.display = 'block');

        this.resultTabs.querySelectorAll('li')
            .forEach(btn => btn.classList.remove('current'));

        this.resultTabs.querySelector('li:first-child').classList.add('current');
    };

    setCurrentSectionVisible () {
        document.querySelectorAll('.search-result-section')
            .forEach(section => {
                if ( section.dataset.slug === this.currentItem ) {
                    section.style.display = 'block';
                } else {
                    section.style.display = 'none';
                }
            });

        this.resultTabs.querySelectorAll('li')
            .forEach(btn => btn.classList.remove('current'));

        this.resultTabs.querySelector(`li[data-slug="${this.currentItem}"]`).classList.add('current');
    };

}
